export enum DragTypes {
  RATE = 'RATE',
  CONTAINER = 'CONTAINER',
}
